import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

/**
 * Switch + inline helper text — used for boolean form fields where
 * "True / False" select dropdowns would lose intent.
 *
 * Dimming the entire row (`disabled`) is what flagged-off behaviour fields
 * use to signal that a parent toggle has gated this one (e.g. "Reject
 * Service Intervention" depends on "User Editable" being on).
 */
const SwitchRow = ({ label, helper, checked, onChange, name, disabled }) => (
  <Box
    sx={{
      opacity: disabled ? 0.45 : 1,
      pointerEvents: disabled ? 'none' : 'auto',
      transition: 'opacity 160ms ease',
    }}
  >
    <FormControlLabel
      control={<Switch checked={!!checked} onChange={onChange} name={name} />}
      label={
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {label}
          </Typography>
          {helper && (
            <Typography variant="caption" color="text.secondary">
              {helper}
            </Typography>
          )}
        </Box>
      }
      sx={{ alignItems: 'flex-start', m: 0 }}
    />
  </Box>
);

export default SwitchRow;
